import { Typography } from '@kizen/kds/Typography';
import { useEffect } from 'react';
import { Spacer } from '@kizen/kds/Spacer';
import { SetupAssistantRow } from './Row';
import { ContainerRow } from '../styles';
import { useSetupAssistant } from '@kizenapps/engine/react';
import { AssistantField } from '@kizenapps/engine';

export const ContainerBlock = ({
  field,
  pluginApiName,
  disabled = false,
}: {
  field: AssistantField;
  pluginApiName: string;
  disabled?: boolean;
}) => {
  const { evaluateExpression, shouldHideField } = useSetupAssistant();
  const columns = field.columns || 1;

  useEffect(() => {
    if (field.when) {
      evaluateExpression(field.when, field.key);
    }
  }, [field.when, evaluateExpression, field.key]);

  if (shouldHideField(field.key)) {
    return null;
  }

  return (
    <div>
      {field.label ? (
        <>
          <Spacer size={15} />
          <Typography variant="header" size="lg" weight="semibold">
            {field.label}
          </Typography>
          <Spacer size={15} />
        </>
      ) : null}
      <ContainerRow columns={columns}>
        {field.fields?.map((f) => {
          return (
            <SetupAssistantRow
              key={f.key}
              field={f}
              pluginApiName={pluginApiName}
              disabled={disabled}
            />
          );
        })}
      </ContainerRow>
    </div>
  );
};
